import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  CircularProgress,
  Backdrop,
  Typography,
  Box
} from "@mui/material";
import React, { memo, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";

import { Global_Data } from "../../globalData/GlobalData";

function DailogMain({ data, open, handleClose, renderComponent, showBulkActionLoading }) {
  const { setOpenModalChildData, setopenModalDataActive, bulkData, isOpenModalChildData, setIsOpenModalChildData } = Global_Data();

  useEffect(() => {
    if (open) {
      setopenModalDataActive(data.component);
      setOpenModalChildData(data?.child);
      setIsOpenModalChildData(false);
    } else {
      setOpenModalChildData([]);
      setopenModalDataActive({});
    }
  }, [open]);

  function replaceURIPlaceholdersBrackets(uri, data) {
    return uri.replace(/[{[](\w+)[}\]]/g, (_, key) => data[key] || "");
  }

  return (
    <>
      <Grid container>
        <Dialog
          open={open}
          aria-labelledby={`${data?.component?.sName}-alert-dialog-title`}
          style={{ zIndex: "1201" }}
          aria-describedby={`${data?.component?.sName}-alert-dialog-description`}
          {...data?.props}
          {...data?.component?.sProps}
          PaperProps={{
            style: {
              filter: isOpenModalChildData ? "blur(3px)" : "none",
              transition: "filter 0.3s ease",
            },
          }}
        >
          <IconButton
            onClick={() => {
              handleClose(false);
            }}
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            <CloseIcon />
          </IconButton>
          <DialogTitle id={`${data?.component?.sType}-alert-dialog-title`}>
            {data?.component?.sLabel}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id={data?.component?.sName}>
              {data?.component?.sDefaultValue?.includes("[")
                ? replaceURIPlaceholdersBrackets(
                    data?.component?.sDefaultValue,
                    bulkData
                  )
                : data?.component?.sDefaultValue}
            </DialogContentText>
            <Grid item>
              <Grid container>{renderComponent(data?.child, data)}</Grid>
            </Grid>
          </DialogContent>
        </Dialog>
      </Grid>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1 }}
        open={showBulkActionLoading}
      >
        <Box textAlign="center">
          <CircularProgress color="inherit" />
          <Typography variant="h6" sx={{ mt: 2 }}>
            Processing, please wait...
          </Typography>
        </Box>
      </Backdrop>
    </>
  );
}

export default memo(DailogMain);
